import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeFourth';
const args = {};

export class ModeFourth extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
